import apiClient from './index';

// Database metadata API endpoints
const metadataApi = {
  // Get list of available schemas
  getSchemas: async () => {
    const response = await apiClient.get('/adss/v1/metadata/schemas');
    return response.data;
  },
  
  // Get tables in a schema
  getTables: async (schemaName) => {
    const response = await apiClient.get(`/adss/v1/metadata/schemas/${schemaName}/tables`);
    return response.data;
  },
  
  // Get columns in a table
  getColumns: async (schemaName, tableName) => {
    const response = await apiClient.get(
      `/adss/v1/metadata/schemas/${schemaName}/tables/${tableName}/columns`
    );
    return response.data;
  },
  
  // Get complete database metadata
  getDatabaseMetadata: async () => {
    const response = await apiClient.get('/adss/v1/metadata/database');
    return response.data;
  },
  
  // Get database stats (simplified view of key database metrics)
  getDatabaseStats: async () => {
    try {
      // First get all schemas
      const schemas = await metadataApi.getSchemas();
      
      // For the first few schemas (to avoid overwhelming requests), get table counts
      const statsPromises = schemas.slice(0, 5).map(async (schema) => {
        try {
          const tables = await metadataApi.getTables(schema);
          return {
            schema,
            tableCount: tables.length,
          };
        } catch (error) {
          return {
            schema,
            tableCount: 0,
            error: true
          };
        }
      });
      
      const schemaStats = await Promise.all(statsPromises);
      
      return {
        totalSchemas: schemas.length,
        accessibleSchemas: schemaStats,
        lastUpdated: new Date().toISOString()
      };
    } catch (error) {
      console.error('Failed to fetch database stats:', error);
      throw error;
    }
  }
};

export default metadataApi;